<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:createByName="{ row }">
        <div>
          <span>{{ row.createByName }}</span>
          <br />
          <span>{{ row.createTime }}</span>
        </div>
      </template>
      <template v-slot:modifyByName="{ row }">
        <div>
          <span>{{ row.modifyByName }}</span>
          <br />
          <span>{{ row.modifyTime }}</span>
        </div>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.bizSysRoleStatus === 'Y' ? 'light' : 'warning'"
          >{{
            row.bizSysRoleStatusName ? row.bizSysRoleStatusName : '--'
          }}</el-tag
        >
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip class="item" effect="dark" content="查看" placement="top">
            <i
              class="el-icon-view tool-btn"
              @click="openEditPage({ pageType: 'detail', params: row })"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="修改"
            placement="top"
            v-allow="'actModify'"
            v-if="row.bizSysRoleStatus != 'N'"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="openEditPage({ pageType: 'edit', params: row })"
            ></i>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            content="复制"
            placement="top"
            v-allow="'actCopy'"
            v-if="row.bizSysRoleStatus != 'N'"
          >
            <i
              class="el-icon-document-copy tool-btn"
              @click="copyRole(row.bizSysRoleID)"
            ></i>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            content="删除"
            placement="top"
            v-allow="'actDel'"
            v-if="row.bizSysRoleStatus != 'N'"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.bizSysRoleID, '删除')"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="恢复"
            placement="top"
            v-allow="'actRecover'"
            v-if="row.bizSysRoleStatus === 'N'"
          >
            <i
              style="font-size:20px"
              class="el-icon-refresh"
              @click="del(row.bizSysRoleID, '恢复')"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  components: {},
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(),
    }
  },
  methods: {
    openEditPage({ pageType, params }) {
      this.$router.push({
        name: 'system-role-detail',
        params: { ...params, pageType },
      })
    },
    copyRole(bizSysRoleID) {
      this.$confirm('确定要复制吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$api
            .sysRoleCopyApi({ bizSysRoleID: bizSysRoleID })
            .then((res) => {
              if (res.status === 200) {
                this.$message({
                  showClose: true,
                  message: res.msg,
                  type: 'success',
                })
                this.$emit('reload')
              }
            })
        })
        .catch(() => {})
    },
    del(bizSysRoleID, msg) {
      this.$confirm('确定要' + msg + '吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$api
            .sysRoleDelApi({ bizSysRoleID: bizSysRoleID })
            .then((res) => {
              if (res.status === 200) {
                this.$message({
                  showClose: true,
                  message: msg + '成功',
                  type: 'success',
                })
               this.$emit('reload')
              }
            })
        })
        .catch(() => {})
    },
    back() {
      this.$emit('submit')
    },
  },
}
</script>
